import shapeTypes from '../../constants/ShapeConstants';

export const uiProperties = {
    ROTATE_FILL_ACTIVE: '#46AFEF',
    ROTATE_FILL_INACTIVE: '#69CD72',
    ROTATE_STROKE_ACTIVE: '#FFFFFF',
    ROTATE_STROKE_INACTIVE: '#FFFFFF',
    CORNER_FILL_ACTIVE: '#FFFFFF',
    CORNER_FILL_INACTIVE: '#46AFEF',
    CORNER_STROKE_ACTIVE: '#46AFEF',
    CORNER_STROKE_INACTIVE: '#FFFFFF',
    CONTROL_FILL_ACTIVE: '#FFFFFF',
    CONTROL_FILL_INACTIVE: '#FFDD5D',
    CONTROL_STROKE_ACTIVE: '#FFDD5D',
    CONTROL_STROKE_INACTIVE: '#FFFFFF',
    PATH_COLOR: '#46AFEF',
    RADIUS: 12,
    STROKE: 1
};

export function detectCurrentAngle (shapeModel, rotationX, rotationY, canvasProperties) {
    let shapeCenter = {x: shapeModel.x + shapeModel.width / 2, y: shapeModel.y + shapeModel.height / 2};
    let angle;
    const canvasScale = canvasProperties.scale;
    let localPoint = {x: (rotationX - canvasProperties.topX) / canvasScale, y:(rotationY - canvasProperties.topY) / canvasScale};

    angle = Math.atan2(localPoint.y - shapeCenter.y, localPoint.x - shapeCenter.x) * 180 / Math.PI;
    angle = angle + 90;

    return angle;
}

export function transformPointToRotatedSystem (point, rotation) {
    let radians = degreesToRadians(rotation);
    let x = point.x * Math.cos(radians) + point.y * Math.sin(radians);
    let y = -point.x * Math.sin(radians) + point.y * Math.cos(radians);

    return {x, y};
}

export function transformPointFromRotatedSystem (point, rotation) {
    let radians = degreesToRadians(rotation);
    let x = point.x * Math.cos(radians) - point.y * Math.sin(radians);
    let y = point.x * Math.sin(radians) + point.y * Math.cos(radians);

    return {x, y};
}

function degreesToRadians (angle) {
    return angle * Math.PI / 180;
}

export function getTouchPosition (e) {
    if (e.clientX != undefined) { // is MouseEvent
        return {x: e.clientX, y: e.clientY};
    } else {
        if (e.touches && e.touches.length > 0)
            return {x: e.touches[0].clientX, y: e.touches[0].clientY};
        else
        if (e.changedTouches)
            return {x: e.changedTouches[0].clientX, y: e.changedTouches[0].clientY};
    }

    return {x: 0, y: 0};
}

export function isTextBubble (shapeModel) {
    if (shapeModel.type == shapeTypes.SPEAK_BUBBLE || shapeModel.type == shapeTypes.COMPLEX_SPEAK_BUBBLE || shapeModel.type == shapeTypes.THOUGHT_BUBBLE || shapeModel.type == shapeTypes.SCREAM_BUBBLE)
        return true;
    else
        return false;
}

export function isTextBox (shapeModel) {
    if (shapeModel == undefined)
        return false;

    if (shapeModel.type == shapeTypes.TEXTBOX || shapeModel.type == shapeTypes.TEXTBOXSIMPLE || isTextBubble(shapeModel) == true)
        return true;
    else
        return false;
}

export function useScaleFactor (type) {
    if (type == shapeTypes.FREEHAND || type == shapeTypes.TEXTBOX || type == shapeTypes.TEXTBOXSIMPLE || type == shapeTypes.SCREAM_BUBBLE || type == shapeTypes.THOUGHT_BUBBLE || type == shapeTypes.SPEAK_BUBBLE || type == shapeTypes.COMPLEX_SPEAK_BUBBLE)
        return false;
    else
        return true;
}



/** WEBPACK FOOTER **
 ** ./src/components/utils/TransformToolUtils.js
 **/